import React, { useState, useMemo, useRef, useContext } from "react";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import CreateActivationPlatformV2 from "../../Modals/CreateActivationPlatformV2";
import { DataTableContext } from "../Tabs/Overview";
import { ViewMasterCampaignsContext } from "../index";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { multipleMasterCampaignsSelected } from "./actionValidations";

export default () => {
	// Define a ref that will be used to open and close the modal
	const dpRef = useRef();
	const [masterCampaignId, setMasterCampaignId] = useState();
	const [masterCampaign, setMasterCampaign] = useState();

	const checkboxContextValue = useContext(DataTableContext);
	const { permissionedDataKeys } = useContext(ViewMasterCampaignsContext);

	const checkboxSelections = checkboxContextValue?.checkboxSelections;
	const dataProvider = checkboxContextValue?.dataProvider;
	const dataTableApi = checkboxContextValue?.dataTableApi;

	// property used to disable the Trigger button given specific criteria
	const disabled = useMemo(() => multipleMasterCampaignsSelected(checkboxSelections) || checkboxSelections?.selectedMasterCampaigns?.length != 1, [checkboxSelections]);

	// Extract the actual selected campaign data from the overall data set
	const availablePlatforms = useMemo(() => {
		if (!disabled) {
			const selection = checkboxSelections?.selectedMasterCampaigns?.[0];
			setMasterCampaignId(selection);
			const selectedMasterCampaign = dataProvider?.data?.find(({ MasterCampaignID }) => MasterCampaignID == selection);
			setMasterCampaign(selectedMasterCampaign);
			return dataProvider?.data?.find(({ MasterCampaignID }) => MasterCampaignID == selection)?.AvailableActivations || [];
		}
		return {};
	}, [checkboxSelections, disabled, dataProvider]);

	const handleAddNewActivationCampaign = () => {
		dpRef.current?.triggerOpenClose?.();
	};

	// Define a button that can be rendered wherever the client desires
	const Trigger = (props) => {
		return (
			<Tooltip title="Add Activation Campaign" position={TOOLTIP_POSITION.BOTTOM}>
				<Button
					display={BUTTON_DISPLAY.ICON_BORDERED}
					disabled={disabled}
					size={BUTTON_SIZE.SMALL}
					icon="icon-add-small"
					className="add-activation-campaign-button"
					id="toggleActivationPlatformMenuButton"
					onClick={handleAddNewActivationCampaign}
					data-tracking-id-alt="add-activation-campaign-button"
				>
					Activation Platform
				</Button>
			</Tooltip>
		);
	};

	// Define  the component that should be displayed when the trigger is clicked
	const DisplayedComponent = () => {
		if (masterCampaignId && availablePlatforms) {
			return (
				<CreateActivationPlatformV2
					apRef={(ref) => {
						dpRef.current = ref;
					}}
					availablePlatforms={availablePlatforms || []}
					selectedMasterCampaignID={masterCampaignId}
					masterCampaign={masterCampaign}
					// refresh={refreshData}
					refresh={() => {
						dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
						setTimeout(() => {
							dataProvider.update();
						}, 1);
					}}
					permissionedDataKeys={permissionedDataKeys}
				/>
			);
		}

		return <></>;
	};

	// Return a memoized object containing both of these components
	return useMemo(() => ({ Trigger, DisplayedComponent }), [masterCampaignId, masterCampaign, dataProvider, availablePlatforms, disabled]);
};
